import { Category } from "../models/projectModel";

export const web: Category = {
  key: "web",
  name: "Web",
};

export const mobile: Category = {
  key: "mobile",
  name: "Mobile",
};

export const gui: Category = {
  key: "gui",
  name: "GUI",
};
export const other: Category = {
  key: "other",
  name: "Other",
};

export const macro: Category = {
  key: "macro",
  name: "Macro",
};

export const productDesign: Category = {
  key: "productDesign",
  name: "Product Design",
};

export const cadDesign: Category = {
  key: "cadDesign",
  name: "CAD Design",
};

export const allCategories = [
  web,
  mobile,
  gui,
  other,
  productDesign,
  cadDesign,
];


export function CategoryFromKey(key:string) {
  const category =  allCategories.find((e)=> e.key === key);
  return category;
  
}